import { render, staticRenderFns } from "./frontside.vue?vue&type=template&id=56e68430&scoped=true&"
import script from "./frontside.vue?vue&type=script&lang=js&"
export * from "./frontside.vue?vue&type=script&lang=js&"
import style0 from "./frontside.vue?vue&type=style&index=0&id=56e68430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e68430",
  null
  
)

export default component.exports